import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetAvailableVatValuesQueryResponse, GetAvailableVatValues400, GetAvailableVatValues401, GetAvailableVatValues403, GetAvailableVatValues422, GetAvailableVatValues429, GetAvailableVatValues500 } from "../types/GetAvailableVatValues";

export const getAvailableVatValuesQueryKey = () =>     [{url:`/api/purchase-tenders/private/v1/bid/view_vat-list`}] as const;
      export function getAvailableVatValuesQueryOptions <TData = GetAvailableVatValuesQueryResponse, TError = GetAvailableVatValues400 | GetAvailableVatValues401 | GetAvailableVatValues403 | GetAvailableVatValues422 | GetAvailableVatValues429 | GetAvailableVatValues500>(options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getAvailableVatValuesQueryKey();

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/purchase-tenders/private/v1/bid/view_vat-list`,
              
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @link /api/purchase-tenders/private/v1/bid/view_vat-list
 */

export function useGetAvailableVatValues <TData = GetAvailableVatValuesQueryResponse, TError = GetAvailableVatValues400 | GetAvailableVatValues401 | GetAvailableVatValues403 | GetAvailableVatValues422 | GetAvailableVatValues429 | GetAvailableVatValues500>(options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getAvailableVatValuesQueryKey();

  const query = useQuery<TData, TError>({
    ...getAvailableVatValuesQueryOptions<TData, TError>(clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
